function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/tabs.ts
import { tabsAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
import { getColor } from "@chakra-ui/theme-tools";
var $fg = cssVar("tabs-color");
var $bg = cssVar("tabs-bg");
var $border = cssVar("tabs-border-color");
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var baseStyleRoot = defineStyle(function (props) {
  var orientation = props.orientation;
  return {
    display: orientation === "vertical" ? "flex" : "block"
  };
});
var baseStyleTab = defineStyle(function (props) {
  var isFitted = props.isFitted;
  return {
    flex: isFitted ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
});
var baseStyleTablist = defineStyle(function (props) {
  var _props$align = props.align,
    align = _props$align === void 0 ? "start" : _props$align,
    orientation = props.orientation;
  var alignments = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: alignments[align],
    flexDirection: orientation === "vertical" ? "column" : "row"
  };
});
var baseStyleTabpanel = defineStyle({
  p: 4
});
var baseStyle = definePartsStyle(function (props) {
  return {
    root: baseStyleRoot(props),
    tab: baseStyleTab(props),
    tablist: baseStyleTablist(props),
    tabpanel: baseStyleTabpanel
  };
});
var sizes = {
  sm: definePartsStyle({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: definePartsStyle({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: definePartsStyle({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
};
var variantLine = definePartsStyle(function (props) {
  var c = props.colorScheme,
    orientation = props.orientation;
  var isVertical = orientation === "vertical";
  var borderProp = isVertical ? "borderStart" : "borderBottom";
  var marginProp = isVertical ? "marginStart" : "marginBottom";
  return {
    tablist: _defineProperty(_defineProperty({}, borderProp, "2px solid"), "borderColor", "inherit"),
    tab: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, borderProp, "2px solid"), "borderColor", "transparent"), marginProp, "-2px"), "_selected", _defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty({}, $fg.variable, "colors.".concat(c, ".300"))), "borderColor", "currentColor")), "_active", _defineProperty(_defineProperty({}, $bg.variable, "colors.gray.200"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.300"))), "_disabled", {
      _active: {
        bg: "none"
      }
    }), "color", $fg.reference), "bg", $bg.reference)
  };
});
var variantEnclosed = definePartsStyle(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty(_defineProperty(_defineProperty({
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px"
    }, $border.variable, "transparent"), "_selected", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".600")), $border.variable, "colors.white"), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".300")), $border.variable, "colors.gray.800")), "borderColor", "inherit"), "borderBottomColor", $border.reference)), "color", $fg.reference),
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantEnclosedColored = definePartsStyle(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      border: "1px solid",
      borderColor: "inherit"
    }, $bg.variable, "colors.gray.50"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.50")), "mb", "-1px"), "_notLast", {
      marginEnd: "-1px"
    }), "_selected", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $bg.variable, "colors.white"), $fg.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty(_defineProperty({}, $bg.variable, "colors.gray.800"), $fg.variable, "colors.".concat(c, ".300"))), "borderColor", "inherit"), "borderTopColor", "currentColor"), "borderBottomColor", "transparent")), "color", $fg.reference), "bg", $bg.reference),
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantSoftRounded = definePartsStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: getColor(theme, "".concat(c, ".700")),
        bg: getColor(theme, "".concat(c, ".100"))
      }
    }
  };
});
var variantSolidRounded = definePartsStyle(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      borderRadius: "full",
      fontWeight: "semibold"
    }, $fg.variable, "colors.gray.600"), "_dark", _defineProperty({}, $fg.variable, "inherit")), "_selected", _defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.white"), $bg.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.gray.800"), $bg.variable, "colors.".concat(c, ".300")))), "color", $fg.reference), "bg", $bg.reference)
  };
});
var variantUnstyled = definePartsStyle({});
var variants = {
  line: variantLine,
  enclosed: variantEnclosed,
  "enclosed-colored": variantEnclosedColored,
  "soft-rounded": variantSoftRounded,
  "solid-rounded": variantSolidRounded,
  unstyled: variantUnstyled
};
var tabsTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
});
export { tabsTheme };